import React, { useState, useEffect, useRef } from 'react';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

import Logo  from '../images/logo.png'

import { useAuth } from "../hooks/useAuth";

export const Login = () => {
	const { login } = useAuth();
	const [username, setUsername] = useState('');
	const [password, setPassword] = useState('');
	const [displayBadLogin, setDisplayBadLogin] = useState(false);

	useEffect(() => {
        let savedEmail = localStorage.getItem('email')
		if (savedEmail) {
			setUsername(savedEmail)
			setRememberMe(true)
		}
    }, []);

	const toast = useRef(null);

	const handleSubmit = async (event) => {
		event.preventDefault();
		const data = new FormData(event.currentTarget);
		let results = await login({
			username: data.get("username"),
		 	password: data.get("password")
		});

		if (!results) setDisplayBadLogin(true)
	  };

	 return (
        <div className="login-body">
			<Toast ref={toast} />
			<div className="card flex flex-column">
				<div className="top">
					<div className="flex align-content-center flex-wrap">
						<div className="logos">
							<img src={Logo} />
						</div>
						<div className="ml-2 logoText flex align-items-center justify-content-center">
							CURRY ROCKEFELLER GROUP
						</div>
					</div>
					
				</div>
				<div className="login-form flex justify-content-center ">
					<form onSubmit={handleSubmit}>
						<div className="p-field">
							<label htmlFor="username" className="p-d-block">Email</label>
							<InputText id="username" autoComplete="username" name="username"  className="p-d-block" value={username} onChange={(e) => setUsername(e.target.value)}/>
						</div>

						<div className="p-field">
							<label htmlFor="password" className="p-d-block">Password</label>
							<Password id="password" autoComplete="current-password" name="password" className="p-d-block" feedback={false} onChange={(e) => setPassword(e.target.value)} />
						</div>

						{displayBadLogin && 
							<div className="red">
								Incorrect Login Information
							</div>
						}

						<div className="p-field">
							<Button type="submit" label="Sign In"></Button>
						</div>

						
					</form>
				</div>
			</div>
		</div>
	);
}
